import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  NbThemeModule,
  NbLayoutModule,
  NbMenuModule,
  NbToastrModule,
  NbDatepickerModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import {
  NbPasswordAuthStrategy,
  NbAuthModule,
  NbAuthJWTToken,
} from '@nebular/auth';
import { HttpClientModule } from '@angular/common/http';
import { Global } from './global';
import { AuthGuard } from './core/security/auth.guard';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AbilityModule } from '@casl/angular';
import { Ability, PureAbility } from '@casl/ability';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { UserStorage } from './core/security/user.storage';

// import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [
    AppComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    // NgxPaginationModule,
    AbilityModule,
    NbThemeModule.forRoot({ name: 'default' }),
    NbLayoutModule,
    NbEvaIconsModule,
    NbMenuModule.forRoot(),
    NbToastrModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          //  baseEndpoint: 'http://10.250.20.215:8093',
          // baseEndpoint: 'http://localhost:8093',
          baseEndpoint: 'https://receipting.nyaradzo.sahwi.net',
          //  baseEndpoint: 'http://10.250.20.190:8093',
          // baseEndpoint: 'http://196.214.41.14:8093',
          // baseEndpoint: 'http://auth.nyaradzo.co.za:8093',
          //  baseEndpoint:'http://172.31.9.195:8093',
          //  baseUrl = 'http://172.31.16.158:8093',
          login: {
            endpoint: '/v1/api/authentication',
            method: 'post',
            redirect: {
              success: '/m/dashboard',
              failure: null, // stay on the same page
            },
          },
          register: {
            endpoint: '/api/auth/register',
          },
          token: {
            class: NbAuthJWTToken,
            key: 'token',
          },
        }),
      ],
      forms: {},
    }),
  ],
  providers: [
    UserStorage,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    Global,
    AuthGuard,
    { provide: Ability, useValue: new Ability() },
    { provide: PureAbility, useExisting: Ability },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
